export default {
  sqlDatabase: 'SQL Database',
  goBack: 'Return to previous page',
  title: 'An unexpected error occurred',
  subTitle: 'Please try again',
  message: 'If the problem persists please contact technical support.',
};
